const API_PREFIX = "/api";
const DEFAULT_API_BASE = import.meta.env?.VITE_API_URL ?? API_PREFIX;

// Pixel URLs live at the HOST ROOT (/data/...), never under /api: nginx routes
// /data/ to the serving pool, whereas /api/* goes to the single api replica.
// Strip a trailing /api from the base (bare "/api" or "https://host/api").
export const buildPixelUrl = (
  pixelUuid,
  ext,
  origin,
  apiBase = DEFAULT_API_BASE,
) => {
  let base = apiBase.replace(/\/+$/, "");
  if (base.endsWith(API_PREFIX)) {
    base = base.slice(0, -API_PREFIX.length);
  }
  const path = `${base}/data/${pixelUuid}.${ext}`;
  try {
    return new URL(path, origin || window.location.origin).href;
  } catch {
    return path;
  }
};

// `brandName` labels the HTML comment publishers paste into their pages.
const pixelLabel = (brandName) => (brandName ? `${brandName} pixel` : "pixel");

export const buildPixelSnippet = (pixelUuid, origin, apiBase, brandName) => {
  const tagUrl = buildPixelUrl(pixelUuid, "js", origin, apiBase);
  return `<!-- ${pixelLabel(brandName)} -->\n<script async src="${tagUrl}"></script>`;
};

export const buildPixelImage = (pixelUuid, origin, apiBase, brandName) => {
  const gifUrl = buildPixelUrl(pixelUuid, "gif", origin, apiBase);
  return `<!-- ${pixelLabel(brandName)} (no JavaScript) -->\n<img src="${gifUrl}" width="1" height="1" alt="" style="display:none" />`;
};

export const buildPixelNoscript = (pixelUuid, origin, apiBase) => {
  const gifUrl = buildPixelUrl(pixelUuid, "gif", origin, apiBase);
  return `<noscript><img src="${gifUrl}" width="1" height="1" alt="" style="display:none" /></noscript>`;
};
